// L'API de WooCommerce pot retornar textos amb entitats HTML (p.ex. "&amp;")
export function decodeHtmlEntities(text: string): string {
  if (!text) return '';
  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;
  return textarea.value;
}
